module.exports = __webpack_public_path__ + "static/media/dog.430bdc95.jpg";